const BLOCKED_PATHS = ['/sign-in', '/auth/verify'];

export const isSafeRedirect = (path: unknown): path is string => {
  if (typeof path !== 'string' || path.length === 0) {
    return false;
  }
  if (!path.startsWith('/') || path.startsWith('//')) {
    return false;
  }
  return !BLOCKED_PATHS.includes(path);
};
